module.exports = {"652929100":"柯坪镇","652929101":"盖孜力克镇","652929102":"阿恰勒镇","652929201":"玉尔其乡","652929203":"启浪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652929.json
// module id = 3242
// module chunks = 0